module.exports = __webpack_public_path__ + "images/ffbfc8ed2da2d1403a04c97f559cbead.webp";